var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tnkc-timeline-app",attrs:{"id":"calendar"}},[_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }